/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AddressDto } from "./AddressDto";
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
} from "./AddressDto";
import type { DeviceDto } from "./DeviceDto";
import {
    DeviceDtoFromJSON,
    DeviceDtoFromJSONTyped,
    DeviceDtoToJSON,
} from "./DeviceDto";
import type { UserAccountSummary } from "./UserAccountSummary";
import {
    UserAccountSummaryFromJSON,
    UserAccountSummaryFromJSONTyped,
    UserAccountSummaryToJSON,
} from "./UserAccountSummary";

/**
 *
 * @export
 * @interface DeviceOwnerDto
 */
export interface DeviceOwnerDto {
    /**
     *
     * @type {number}
     * @memberof DeviceOwnerDto
     */
    deviceOwnerId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    accountStatus?: DeviceOwnerDtoAccountStatusEnum;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    type?: DeviceOwnerDtoTypeEnum;
    /**
     *
     * @type {number}
     * @memberof DeviceOwnerDto
     */
    ownerUserAccountId?: number;
    /**
     * Old single field Address.
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    address?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    mobileNo?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    email?: string;
    /**
     *
     * @type {Date}
     * @memberof DeviceOwnerDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceOwnerDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof DeviceOwnerDto
     */
    internalNotes?: string;
    /**
     *
     * @type {Array<DeviceDto>}
     * @memberof DeviceOwnerDto
     */
    devices?: Array<DeviceDto>;
    /**
     *
     * @type {UserAccountSummary}
     * @memberof DeviceOwnerDto
     */
    ownerUserAccount?: UserAccountSummary;
    /**
     *
     * @type {AddressDto}
     * @memberof DeviceOwnerDto
     */
    ownerAddress?: AddressDto;
}

/**
 * @export
 */
export const DeviceOwnerDtoAccountStatusEnum = {
    Invited: "Invited",
    Pending: "Pending",
    Active: "Active",
    Suspended: "Suspended",
    Closed: "Closed",
} as const;
export type DeviceOwnerDtoAccountStatusEnum =
    (typeof DeviceOwnerDtoAccountStatusEnum)[keyof typeof DeviceOwnerDtoAccountStatusEnum];

/**
 * @export
 */
export const DeviceOwnerDtoTypeEnum = {
    Private: "Private",
    SiteManager: "SiteManager",
} as const;
export type DeviceOwnerDtoTypeEnum =
    (typeof DeviceOwnerDtoTypeEnum)[keyof typeof DeviceOwnerDtoTypeEnum];

/**
 * Check if a given object implements the DeviceOwnerDto interface.
 */
export function instanceOfDeviceOwnerDto(
    value: object,
): value is DeviceOwnerDto {
    return true;
}

export function DeviceOwnerDtoFromJSON(json: any): DeviceOwnerDto {
    return DeviceOwnerDtoFromJSONTyped(json, false);
}

export function DeviceOwnerDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceOwnerDto {
    if (json == null) {
        return json;
    }
    return {
        deviceOwnerId:
            json["deviceOwnerId"] == null ? undefined : json["deviceOwnerId"],
        accountStatus:
            json["accountStatus"] == null ? undefined : json["accountStatus"],
        type: json["type"] == null ? undefined : json["type"],
        ownerUserAccountId:
            json["ownerUserAccountId"] == null
                ? undefined
                : json["ownerUserAccountId"],
        address: json["address"] == null ? undefined : json["address"],
        name: json["name"] == null ? undefined : json["name"],
        mobileNo: json["mobileNo"] == null ? undefined : json["mobileNo"],
        email: json["email"] == null ? undefined : json["email"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        internalNotes:
            json["internalNotes"] == null ? undefined : json["internalNotes"],
        devices:
            json["devices"] == null
                ? undefined
                : (json["devices"] as Array<any>).map(DeviceDtoFromJSON),
        ownerUserAccount:
            json["ownerUserAccount"] == null
                ? undefined
                : UserAccountSummaryFromJSON(json["ownerUserAccount"]),
        ownerAddress:
            json["ownerAddress"] == null
                ? undefined
                : AddressDtoFromJSON(json["ownerAddress"]),
    };
}

export function DeviceOwnerDtoToJSON(value?: DeviceOwnerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceOwnerId: value["deviceOwnerId"],
        accountStatus: value["accountStatus"],
        type: value["type"],
        ownerUserAccountId: value["ownerUserAccountId"],
        address: value["address"],
        name: value["name"],
        mobileNo: value["mobileNo"],
        email: value["email"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        internalNotes: value["internalNotes"],
        devices:
            value["devices"] == null
                ? undefined
                : (value["devices"] as Array<any>).map(DeviceDtoToJSON),
        ownerUserAccount: UserAccountSummaryToJSON(value["ownerUserAccount"]),
        ownerAddress: AddressDtoToJSON(value["ownerAddress"]),
    };
}
